import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class ChatWindowComponent extends Component {
  @service chatv2;

  @action
  toggleRecentChatsIsVisible() {
    this.args.toggleRecentChatsIsVisible();
  }

  @action
  async handleNewChat() {
    await this.chatv2.unsetActiveConversation();
  }
}
